import React from 'react';

import { ComponentType, ComponentStyle } from '../../../types/types';

import Header from '../../../components/Header';

type Props = {
  title: string;
  description: string;
  image?: string;
};

export const LandingPageHeader: React.FC<Props> = props => (
  <Header
    productComponent={{
      title: props.title,
      description: props.description,
      type: ComponentType.Header,
      style: ComponentStyle.C,
      image: props.image,
    }}
  />
);
